const W = 0.52;
const M = 0.06;

export const mainKeys = {
  "0x29": { text: "Esc", style: { marginRight: M * 2 + W + "rem" } },
  "0x3a": { text: "F1" },
  "0x3b": { text: "F2" },
  "0x3c": { text: "F3" },
  "0x3d": {
    text: "F4",
    style: { marginRight: M + (M + W) * 0.5 + "rem" },
  },
  "0x3e": { text: "F5" },
  "0x3f": { text: "F6" },
  "0x40": { text: "F7" },
  "0x41": {
    text: "F8",
    style: { marginRight: M + (M + W) * 0.5 + "rem" },
  },
  "0x42": { text: "F9" },
  "0x43": { text: "F10" },
  "0x44": { text: "F11" },
  "0x45": { text: "F12" },
  "0x35": { text: "~<br/>`" },
  "0x1e": { text: "!<br/>1" },
  "0x1f": { text: "@<br/>2" },
  "0x20": { text: "#<br/>3" },
  "0x21": { text: "$<br/>4" },
  "0x22": { text: "%<br/>5" },
  "0x23": { text: "^<br/>6" },
  "0x24": { text: "&<br/>7" },
  "0x25": { text: "*<br/>8" },
  "0x26": { text: "(<br/>9" },
  "0x27": { text: ")<br/>0" },
  "0x2d": { text: "_<br/>-" },
  "0x2e": { text: "+<br/>=" },
  "0x2a": { text: "Backspace", style: { width: W * 2 + M + "rem" } },
  "0x2b": { text: "Tab", style: { width: W + (W + M) * 0.5 + "rem" } },
  "0x14": { text: "Q" },
  "0x1a": { text: "W" },
  "0x08": { text: "E" },
  "0x15": { text: "R" },
  "0x17": { text: "T" },
  "0x1c": { text: "Y" },
  "0x18": { text: "U" },
  "0x0c": { text: "I" },
  "0x12": { text: "O" },
  "0x13": { text: "P" },
  "0x2f": { text: "{<br/>[" },
  "0x30": { text: "}<br/>]" },
  "0x31": {
    text: "|<br/>\\",
    style: { width: W + (W + M) * 0.5 + "rem" },
  },
  "0x39": { text: "CapsLock", style: { width: W + W * 0.75 + M + "rem" } },
  "0x04": { text: "A" },
  "0x16": { text: "S" },
  "0x07": { text: "D" },
  "0x09": { text: "F" },
  "0x0a": { text: "G" },
  "0x0b": { text: "H" },
  "0x0d": { text: "J" },
  "0x0e": { text: "K" },
  "0x0f": { text: "L" },
  "0x33": { text: ":<br/>;" },
  "0x34": { text: "\"<br/>'" },
  "0x28": { text: "Enter", style: { width: W + W * 1.25 + M + "rem" } },
  "0xe1": {
    text: "LShift",
    style: { width: W + W * 1.25 + M * 1.5 + "rem" },
  },
  "0x1d": { text: "Z" },
  "0x1b": { text: "X" },
  "0x06": { text: "C" },
  "0x19": { text: "V" },
  "0x05": { text: "B" },
  "0x11": { text: "N" },
  "0x10": { text: "M" },
  "0x36": { text: "<<br/>," },
  "0x37": { text: "><br/>." },
  "0x38": { text: "?<br/>/" },
  "0xe5": {
    text: "RShift",
    style: { width: W + W * 1.75 + M * 1.5 + "rem" },
  },
  "0xe0": { text: "LCtrl ", style: { width: W * 1.3 + "rem" } },
  "0xe3": { text: "LCode", style: { width: W * 1.3 + "rem" } },
  "0xe2": { text: "LAlt", style: { width: W * 1.3 + "rem" } },
  "0x2c": { text: "Space", style: { width: W * 6.7 + "rem" } },
  "0xe6": { text: "RAlt", style: { width: W * 1.3 + "rem" } },
  "0xe7": { text: "RCode", style: { width: W * 1.3 + "rem" } },
  "0x65": { text: "Menu", style: { width: W * 1.3 + "rem" } },
  "0xe4": { text: "RCtrl", style: { width: W * 1.3 + "rem" } },
};

export const centerClusterKeys = {
  "0x53": {
    text: "Print Screen",
  },
  "0x47": { text: "Scroll Lock" },
  "0x48": { text: "Pause" },
  "0x49": { text: "Insert" },
  "0x4a": { text: "Home" },
  "0x4b": { text: "Page Up" },
  "0x4c": { text: "Delete" },
  "0x4d": { text: "End" },
  "0x52": {
    text: "↑",
    style: {
      marginTop: M + W + "rem",
      marginRight: M + W + "rem",
      marginLeft: M + W + "rem",
    },
  },
  "0x50": { text: "←" },
  "0x51": { text: "↓" },
  "0x4f": { text: "→" },
};

export const numpadKeys = {
  "0x53": {
    text: "Num Lock",
    style: { marginTop: M + W + "rem" },
  },
  "0x54": { text: "/", style: { marginTop: M + W + "rem" } },
  "0x55": { text: "*", style: { marginTop: M + W + "rem" } },
  "0x56": { text: "-", style: { marginTop: M + W + "rem" } },
  "0x5f": { text: "7" },
  "0x60": { text: "8" },
  "0x61": { text: "9" },
  "0x57": { text: "+" },
  "0x5c": { text: "4" },
  "0x5d": { text: "5" },
  "0x5e": { text: "6", style: { marginRight: M + W + "rem" } },
  "0x59": { text: "1" },
  "0x5a": { text: "2" },
  "0x5b": { text: "3", style: { marginRight: M + W + "rem" } },
  "0x62": { text: "0", style: { width: M + W * 2 + "rem" } },
  "0x63": { text: "." },
  "0x58": { text: "Enter" },
};

export const mouseKeys = {
  "0xf0": { text: "Left" },
  "0xf1": { text: "Right" },
  "0xf2": { text: "Wheel" },
  "0xf3": { text: "Back" },
  "0xf4": { text: "Forward" },
};

export const allKeys = {
  ...mainKeys,
  ...centerClusterKeys,
  ...numpadKeys,
  ...mouseKeys,
};

export default {
  mainKeys,
  centerClusterKeys,
  numpadKeys,
  mouseKeys,
  allKeys,
};
